<template>
    <div class="hints-dialog">
        <HLCardLayout class="pt-0" :class="{'fixed-width': !isXsDevice, 'full-width': isXsDevice}" :scale="(isXsDevice)?0.75:(isXlDevice)?0.4:0.7" :loading="false" :minHeight="(isSmAndUpDevice)?'600':null" disableFooterPadding :disablePadding="isXsDevice" :horizontalMargin="!isXsDevice">
            <template #header-action>
<!--                <v-btn-->
<!--                    v-if="!isXsDevice"-->
<!--                    class="mb-sm-2 ml-n3"-->
<!--                    elevation="0"-->
<!--                    fab-->
<!--                    dark-->
<!--                    small-->
<!--                    @click.stop="onCancel"-->
<!--                    color="white"-->
<!--                >-->
<!--                    <v-icon dark color="black" opacity="0.5">-->
<!--                        mdi-close-->
<!--                    </v-icon>-->
<!--                </v-btn>-->
            </template>

            <template #menuTitle>
                <h3 class="three-dots px-sm-6 grey--text text--darken-3" :class="{'text-center':true}" :style="{'color': theme.textColor + '!important'}">{{$t('hints')}}</h3>
            </template>

            <template #content>
                <v-slide-group show-arrows v-model="selectedIndex" class="mb-6 hints-slide-group">
                    <v-slide-item v-for="(hint, i) in hintsList" :key="hint.id_hint" :value="i" class="hint-slide-item">
                        <v-card @click="onSelectHint(i)" :class="[{'hint-tab--active': isHintSelected(i), 'hint-tab--locked': !isHintUnlocked(hint) }]" rounded elevation="isHintUnlocked(hint)?2:0" :style="getHintCardStyle(i)" height="150">
                            <v-card-text class="d-flex flex-column align-center text-center fill-height pa-0">
                                <div class="spacer"></div>
                                <div class="px-0 font-weight-medium hint-title" :style="isHintSelected(i) ? {'color': theme.btnTextColor} : {'color': theme.textColor}">{{ hint.name }}</div>
                                <div class="spacer"></div>
                                <v-icon v-if="!isHintUnlocked(hint)" class="mb-3" size="36" :color="isHintSelected(i) ? theme.btnTextColor : theme.textColor">mdi-lock</v-icon>
                                <v-icon v-else class="mb-3" size="36" :color="isHintSelected(i) ? theme.btnTextColor : theme.textColor">mdi-lock-open-variant</v-icon>
                            </v-card-text>
                        </v-card>
                    </v-slide-item>
                </v-slide-group>

                <div v-if="currentHint">
                    <div v-if="!isHintUnlocked(currentHint)" class="d-flex flex-column align-center justify-center text-center">
                        <div class="mb-4 d-flex align-center px-0" :style="{'color': theme.textColor}">
                            <span class="mr-2">{{ currentHint.points }}</span>
                            <v-icon :color="theme.textColor">mdi-star</v-icon>
                        </div>
                        <v-btn 
                            :color="theme.btnColorPrimary" 
                            class="white--text" 
                            rounded 
                            large 
                            :disabled="isLoadingHintRequest"
                            :loading="isLoadingHintRequest"
                            @click="onRequestHint(currentHint)"
                        >
                            {{ $t('hintUse') }}
                        </v-btn>
                    </div>
                    <div v-else class="hint-content" :style="{'color': theme.textColor}" v-html="getHintDescription(currentHint)"></div>
                </div>
            </template>

            <template #footer>
                <v-btn @click="onCancel" large block depressed rounded dark :opacity="0.8">
                    {{$t('close')}}
                </v-btn>
            </template>
        </HLCardLayout>
    </div>

</template>

<script>
import HLCardLayout from "../../components/dashboard/HLCardLayout.vue";
import {layoutMixin} from "../../utils/layout-mixin";
import {eventMixin} from "../../utils/event-mixin";
import {spotMixin} from "../../utils/spot-mixin";
import Utils from "../../store/modules/base";

export default {
    mixins: [layoutMixin, eventMixin, spotMixin],
    components:{
        HLCardLayout
    },
    props:{
        spot:{}
    },
    data(){
        return {
            selectedIndex: 0
        }
    },
    computed: {
        hintsList(){
            if(!this.spot || !this.spot.raetsel || !this.spot.raetsel.hints){
                return [];
            }
            const values = Object.values(this.spot.raetsel.hints);
            return values.sort((a,b)=>{
                const ao = typeof a.order==='number'?a.order:0;
                const bo = typeof b.order==='number'?b.order:0;
                return ao - bo;
            });
        },
        hintItemWidth(){
            const count = this.hintsList.length;
            if(count <= 1){
                return '80%';
            }
            if(count === 2){
                return '50%';
            }
            if(count === 3){
                return '33%';
            }
            return '40%';
        },
        currentHint(){
            if(this.hintsList.length===0){
                return null;
            }
            const idx = Math.min(Math.max(this.selectedIndex,0), this.hintsList.length-1);
            return this.hintsList[idx];
        }
    },
    methods: {
        isHintUnlocked(hint){
            return !!(hint && hint.timestamp);
        },
        isHintSelected(index){
            return this.selectedIndex === index && this.hintsList.length > 1;
        },
        onSelectHint(index){
            this.selectedIndex = index;
        },
        getHintCardStyle(index){
            const style = { width: this.hintItemWidth, minWidth: this.hintItemWidth, border: `1px solid ${this.theme.textColor}`};
            if (this.isHintSelected(index)){
                style.background = this.theme.btnColorPrimary;
            } else {
                style.background = this.theme.backgroundColor;
            }
            return style;
        },
        onRequestHint(hint){
            this.$emit('requestHint', hint.id_hint);
        },
        getHintDescription(hint) {
            return Utils.replaceKeywords(hint.descr, this.getOfflineStatistic, this.allSpots, this.keywordExtras)
        },
        onCancel(){
            this.$emit('cancel');
        }
    }
}
</script>

<style lang="scss">
.hint-content img {
    max-width: 100%;
}
.hints-slide-group {
    width: 100%;
    .v-slide-group__wrapper {
        width: 100%;
        padding: 0 8px;
    }
    .v-slide-group__content {
        width: 100%;
        display: flex;
        justify-content: center !important;
        align-items: stretch;
    }
    .hint-slide-item {
        margin-right: 8px;
        &:last-child {
            margin-right: 0;
        }
    }
}
.fixed-width {
    width: 680px;
    max-width: 90vw;
}
.full-width {
    width: 100vw;
    max-width: 100vw;
}
.spacer { flex: 1 1 auto; }
.hint-title {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
</style>


